import { Component, OnInit, OnDestroy } from '@angular/core';
import { PumpSystemService } from '../service/pump-system.service';
import { from, mergeMap, map, tap, Subscription, switchMap, of } from 'rxjs';
import { PumpSystem, PumpSystemDetail } from '../../display-product-data/pump-data.model';
import { DisplayProductDataService } from '../../display-product-data/display-product-data.service';
import { UserLocalStorage } from '../../login/user-local-store';
import { PumpSystemItem } from '../../display-product-data/pump-systems/pump-system.model';

@Component({
  selector: 'app-upload-download-components',
  templateUrl: './upload-download-components.component.html',
  styleUrls: ['./upload-download-components.component.scss'],
  standalone: false,
})
export class UploadDownloadComponentsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  pumpSystemList: PumpSystem[] = [];
  userLocalStorage = new UserLocalStorage();
  constructor(private displayProductDataService: DisplayProductDataService) { }
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnInit(): void {

    this.pumpSystemList = [];

    const pumpSystemDetailSubscription = this.displayProductDataService.getPumpSystemList().pipe(
      map(pumpSystemList => this.pumpSystemList = pumpSystemList)
    ).subscribe();
    this.subscriptions.push(pumpSystemDetailSubscription);

  }

  onPublishAllLastVersions() {
    this.updateAllLastPumpVersionsToLive();
  }
  update() {
    this.updateRefsOnPumps();
  }

  private updateAllLastPumpVersionsToLive() {

    const publishePumpVersionsSubscription = from(this.pumpSystemList).pipe(
      mergeMap(pumpSystem => this.findAndPublishPumpVersion(pumpSystem), 4)

    ).subscribe(
      {
        error: (e) => console.error(e),
        complete: () => console.info('###### updateAllLastPumpVersionsToLive complete')
      }
    );
    this.subscriptions.push(publishePumpVersionsSubscription);
  }


  private findAndPublishPumpVersion(pumpSystem: PumpSystem) {
    return this.displayProductDataService.getPumpSystemItem(pumpSystem.uuid).pipe(
      map(pumpSystemDetailMessage => this.extractPumpVersionData(pumpSystemDetailMessage)
      ),
      mergeMap(v => this.updateVersionToLive(v.url, v.data), 4)
    )
  }

  private updateVersionToLive(url: string, data: { author: string; comment: string; }) {
    return this.displayProductDataService.setPumpSystemState(url, data).pipe(
      tap(() => console.log(...data.comment))
    )
  }

  private extractPumpVersionData(pumpSystemDetailMessage: any) {
    const pumpSystemDetail: PumpSystemDetail = JSON.parse(pumpSystemDetailMessage.message);
    const data = { 'author': '', 'comment': '' };
    const user = this.userLocalStorage.loadUser();
    data.author = user?.user?.username || 'Unknown User';
    data.comment = `${pumpSystemDetail.name} changed on component refs import`;
    const url = `${pumpSystemDetail.uuid}/${pumpSystemDetail.versions.length - 1}/live`;
    return { url, data };
  }

  private updateRefsOnPumps() {

    const updatePumpsSubscription = from(this.pumpSystemList).pipe(
      tap(pumpSystem => console.log('the assigned pumpSystem is: ', pumpSystem)),
      mergeMap(pumpSystem => this.assignRefsToEachPump(pumpSystem.uuid), 4),

    ).subscribe(
      {
        error: (e) => console.error(e),
        complete: () => console.info('##### updateRefsOnPumps complete')
      }
    );

    this.subscriptions.push(updatePumpsSubscription);
  }

  private assignRefsToEachPump(pumpUuid: string) {
    return this.displayProductDataService.getPumpSystemItem(pumpUuid).pipe(
      tap(() => console.log('the imported pump uuid is: ', pumpUuid)),
      map(pumpSystemMessage => {

        const pumpSystem: any = JSON.parse(pumpSystemMessage.message);
        //console.log('pump system is ' + pumpSystemMessage.message);
        const pumpSystemItem = pumpSystem.versions[0];

        if (!pumpSystem.versions || pumpSystem.versions.length === 0) {
          console.warn(`Skipping ${pumpUuid}: ${pumpSystem.name} no versions available or versions is null`);
          return pumpSystem;
        }

        if (!pumpSystemItem.motor || !pumpSystemItem.controller || !pumpSystemItem.pump_end ||
          !pumpSystemItem.motor.uuid || !pumpSystemItem.controller.uuid || !pumpSystemItem.pump_end.uuid
        ) {
          console.warn(`Skipping ${pumpUuid}: ${pumpSystem.name} missing motor; ${pumpSystemItem.motor} , controller: ${pumpSystemItem.controller}, or pump_end: ${pumpSystem.pump_end} in the first version`);
          pumpSystem.status = pumpSystemItem.status;
          return pumpSystem;
        }

        const user = this.userLocalStorage.loadUser();

        const payload: PumpSystemItem = {...pumpSystemItem,
        author: user?.user?.username || 'Unknown User',
        comment: `${pumpSystem.name} changed on component refs import`,
        uuid: pumpSystem.uuid,
        name: pumpSystem.name,
        controller_uuid: pumpSystemItem.controller?.uuid,
        pump_end_uuid: pumpSystemItem.pump_end?.uuid,
        motor_uuid: pumpSystemItem.motor?.uuid,
        }


        return payload;
      }),
      mergeMap(pumpSystem => this.displayProductDataService.updatePumpSystem(pumpSystem), 4)
    );
  }

}
